import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardHeader, CardTitle, CardContent } from '../components/Card';
import { Calendar, User } from 'lucide-react';
import { useSEO } from '../hooks/useSEO';
export function Blog() {
  useSEO('Blog - ARWM | Actualités Restauration Marrakech', 'Actualités, conseils et insights du monde de la restauration à Marrakech. Suivez les dernières tendances gastronomiques et réglementations.');
  const [activeTab, setActiveTab] = useState('tous');
  const tabs = [{
    id: 'tous',
    label: 'Tous les articles'
  }, {
    id: 'actualites',
    label: 'Actualités'
  }, {
    id: 'gastronomie',
    label: 'Gastronomie'
  }, {
    id: 'conseils',
    label: 'Conseils'
  }];
  const articles = [{
    id: 'marrakech-capitale-gastronomie',
    category: 'gastronomie',
    date: '10 Décembre 2024',
    author: 'ARWM',
    title: 'Marrakech, Capitale de la Gastronomie Marocaine',
    excerpt: "Découvrez comment Marrakech s'impose comme la destination gastronomique incontournable du Maroc.",
    image: 'https://images.unsplash.com/photo-1414235077428-338989a2e8c0?w=800'
  }, {
    id: 'nouvelles-normes-hygiene',
    category: 'actualites',
    date: '5 Décembre 2024',
    author: 'Bureau ARWM',
    title: "Nouvelles Normes d'Hygiène 2025",
    excerpt: "Point sur les nouvelles réglementations en matière d'hygiène et de sécurité alimentaire.",
    image: 'https://images.unsplash.com/photo-1556910103-1c02745aae4d?w=800'
  }, {
    id: 'conseils-gestion-restaurant',
    category: 'conseils',
    date: '28 Novembre 2024',
    author: 'Experts ARWM',
    title: '10 Conseils pour Optimiser la Gestion de Votre Restaurant',
    excerpt: "Des conseils pratiques pour améliorer la rentabilité et l'efficacité de votre établissement.",
    image: 'https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=800'
  }];
  const filteredArticles = activeTab === 'tous' ? articles : articles.filter(article => article.category === activeTab);
  return <div className="w-full" data-id="element-168">
      {/* Hero */}
      <section className="py-32 px-4 bg-arwm-light-gray" data-id="element-169">
        <div className="max-w-[1280px] mx-auto text-center" data-id="element-170">
          <p className="font-josefin text-arwm-maroon text-sm uppercase tracking-[3.2px] mb-4" data-id="element-171">
            Blog
          </p>
          <h1 className="font-cormorant text-7xl font-bold text-arwm-maroon mb-6" data-id="element-172">
            Blog ARWM
          </h1>
          <p className="font-josefin text-xl text-arwm-dark-text max-w-3xl mx-auto" data-id="element-173">
            Actualités, conseils et insights du monde de la restauration à
            Marrakech
          </p>
        </div>
      </section>

      {/* Filter Tabs */}
      <section className="py-8 px-4 bg-white border-b border-gray-200" data-id="element-174">
        <div className="max-w-[1280px] mx-auto" data-id="element-175">
          <div className="flex flex-wrap gap-4 justify-center" data-id="element-176">
            {tabs.map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`px-6 py-3 font-josefin text-sm uppercase tracking-wider transition-colors ${activeTab === tab.id ? 'bg-arwm-maroon text-arwm-cream' : 'bg-arwm-light-gray text-arwm-dark-text hover:bg-gray-300'}`} data-id="element-177">
                {tab.label}
              </button>)}
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-20 px-4 bg-white" data-id="element-178">
        <div className="max-w-[1280px] mx-auto" data-id="element-179">
          {filteredArticles.length > 0 ? <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-180">
              {filteredArticles.map(article => <Card key={article.id} data-id="element-181">
                  <div className="h-48 bg-cover bg-center" style={{
              backgroundImage: `url(${article.image})`
            }} data-id="element-182" />
                  <CardHeader data-id="element-183">
                    <div className="flex items-center justify-between text-sm text-arwm-maroon mb-2 font-josefin" data-id="element-184">
                      <div className="flex items-center" data-id="element-185">
                        <Calendar className="w-4 h-4 mr-2" data-id="element-186" />
                        <span data-id="element-187">{article.date}</span>
                      </div>
                      <div className="flex items-center" data-id="element-188">
                        <User className="w-4 h-4 mr-2" data-id="element-189" />
                        <span data-id="element-190">{article.author}</span>
                      </div>
                    </div>
                    <CardTitle className="font-cormorant text-2xl" data-id="element-191">
                      {article.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent data-id="element-192">
                    <p className="font-josefin text-arwm-dark-text mb-4" data-id="element-193">
                      {article.excerpt}
                    </p>
                    <Link to={`/blog-posts/${article.id}`} data-id="element-194">
                      <span className="font-josefin text-arwm-maroon text-sm font-semibold hover:underline" data-id="element-195">
                        Lire la suite →
                      </span>
                    </Link>
                  </CardContent>
                </Card>)}
            </div> : <div className="text-center py-20" data-id="element-196">
              <p className="font-josefin text-xl text-arwm-dark-text" data-id="element-197">
                Aucun article dans cette catégorie pour le moment.
              </p>
            </div>}
        </div>
      </section>
    </div>;
}